/**
 * Module-level signal for service worker updates.
 * Solves the race condition where the SW update event fires
 * before React components mount and subscribe.
 */
type Listener = () => void

let available = false
const listeners = new Set<Listener>()

export function signalSwUpdate() {
  available = true
  listeners.forEach((fn) => fn())
}

export function isSwUpdateAvailable() {
  return available
}

export function subscribeSwUpdate(fn: Listener): () => void {
  listeners.add(fn)
  return () => {
    listeners.delete(fn)
  }
}
